import React from 'react';
import { motion } from 'framer-motion';
export function HowItWorksSection() {
  const steps = [{
    num: '1',
    title: 'Compra',
    desc: 'Usas la técnica de las 2 bolsas para traer solo lo que necesitas.',
    emoji: '🛒',
    color: 'bg-blue-100 text-blue-800'
  }, {
    num: '2',
    title: 'Procesa',
    desc: 'Sigues el cronograma de 120 minutos el domingo para dejar tus módulos listos.',
    emoji: '🔪',
    color: 'bg-orange-100 text-orange-800'
  }, {
    num: '3',
    title: 'Ensambla',
    desc: 'Cada noche eliges tus módulos, mezclas y cenas en 5 minutos.',
    emoji: '🍽️',
    color: 'bg-green-100 text-green-800'
  }];
  return <section className="py-16 px-4 sm:px-6 bg-white" data-id="element-50">
      <div className="max-w-5xl mx-auto" data-id="element-51">
        <div className="text-center mb-16" data-id="element-52">
          <h2 className="text-3xl md:text-4xl font-bold text-brand-text mb-4" data-id="element-53">
            ¿Cómo funciona?
          </h2>
          <p className="text-lg text-brand-text/70 max-w-2xl mx-auto" data-id="element-54">
            Un sistema simple de 3 pasos diseñado para eliminar la fricción de
            cocinar.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative" data-id="element-55">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-12 left-[16%] right-[16%] h-1 bg-brand-light -z-10" data-id="element-56"></div>

          {steps.map((step, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.2
        }} className="relative flex flex-col items-center text-center" data-id="element-57">
              <div className={`w-24 h-24 rounded-full flex items-center justify-center text-4xl mb-6 shadow-md border-4 border-white z-10 ${step.color}`} data-id="element-58">
                {step.emoji}
                <div className="absolute -top-2 -right-2 w-8 h-8 rounded-full bg-brand-text text-white text-sm font-bold flex items-center justify-center border-2 border-white" data-id="element-59">
                  {step.num}
                </div>
              </div>
              <h3 className="text-2xl font-bold text-brand-text mb-3" data-id="element-60">
                {step.title}
              </h3>
              <p className="text-brand-text/80 leading-relaxed px-4" data-id="element-61">
                {step.desc}
              </p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.6
      }} className="mt-20 bg-brand-light/30 rounded-2xl p-8 md:p-10 text-center border border-brand-primary/20" data-id="element-62">
          <h3 className="text-2xl md:text-3xl font-bold text-brand-text mb-4" data-id="element-63">
            ¿Qué cambia en 7 días?
          </h3>
          <p className="text-lg text-brand-text/80 leading-relaxed max-w-3xl mx-auto" data-id="element-64">
            El lunes por la noche, por primera vez en meses, no sentirás
            ansiedad al cerrar la oficina. Llegarás a casa sabiendo que la cena
            ya está "pre-decidida". Tendrás 45 minutos extra cada noche para
            descansar, leer o simplemente no hacer nada, mientras tu familia
            disfruta de una comida deliciosa y casera.
          </p>
        </motion.div>
      </div>
    </section>;
}